export default __webpack_public_path__ + "static/media/2452.9d340b23.png";